import { AutogenModelOpenItemCollections, AutogenRowOpenItemCollections } from "./autogen/AutogenModelOpenItemCollections";

export class ModelOpenItemCollections extends AutogenModelOpenItemCollections<RowOpenItemCollections> {
	constructor() {
		super(RowOpenItemCollections);
	}
}

export class RowOpenItemCollections extends AutogenRowOpenItemCollections {
}